import { Dimensions4, Dimensions6, Dimensions8 } from '@efexteam/design-tokens';
import { css } from '@emotion/css';

const wrapper = css({
  padding: `${Dimensions4} ${Dimensions6}`,
  minHeight: '80vh',
});

const alert = css({
  marginTop: Dimensions8,
});

const TransferDetailsStyles = {
  wrapper,
  alert,
};

export default TransferDetailsStyles;
